export const initialArtifactState = {
    loaded: new Map(),
    metadataCache: new Map(),
    controls: new Map(),
    visibility: new Map(),
    loading: new Map(),
    retryCount: new Map(),
    activeOverlays: {
        screen: [],
        info: [],
    },
};
